export default "__VITE_ASSET__DHL5Zy7l__"